import React from 'react';
import dataLayer from '@helpers/dataLayer';
import { SafetyDataSheetDocument } from '@pages/SafetyDatasheet/SafetyDatasheet.types';
import { getURLFileData } from '@helpers/URLHelpers';

interface DatasheetDownloadableItemProps {
  versionLabel: string;
  sizeLabel: string;
  languageLabel: string;
  item: SafetyDataSheetDocument;
}

export const DatasheetDownloadableItem = ({
  versionLabel,
  sizeLabel,
  languageLabel,
  item,
}: DatasheetDownloadableItemProps) => {
  const description = `${versionLabel}${item.Version} ${sizeLabel} ${Math.floor(
    +item.Size / 1024
  )} KB, ${languageLabel} ${item.Language}`;

  const onDownoladDatasheet = () => {
    const { fileName, extension } = getURLFileData(item.PublicUrl);
    dataLayer.push('file_download', {
      file_name: fileName,
      file_extension: extension,
      file_category: undefined,
      file_context: undefined,
      link_text: item.Title,
      link_url: item.PublicUrl,
    });
  };

  return (
    <div className='c-document-hr'>
      <a
        download
        href={item.PublicUrl}
        onClick={onDownoladDatasheet}
        target='_blank'
        rel='noreferrer'
        className='c-document-list-item'
      >
        <div className='c-document-list-item-icon-container'>
          <i className='icon-download'></i>
        </div>
        <div className='c-document-list-item-thumbnail'>
          <i className='icon-pdf svg-icon al-icon-blue'></i>
        </div>

        <div className='c-document-list-item-tail'>
          <div className='c-document-list-item-tail-container'>
            <span className='c-document-list-item-main-text c-document-list-item-word-break'>
              {item.Title}
            </span>
            <span className='c-document-list-item-secondary-text'>{description}</span>
          </div>
        </div>
      </a>
    </div>
  );
};
